// モバイルメニューの制御
window.toggleMobileMenu = function() {
  const menuToggle = document.querySelector('.menu-toggle');
  const headerNav = document.querySelector('.header-nav');
  
  if (!headerNav) return;
  
  // モバイルメニューのスタイルを動的に追加
  if (!document.getElementById('mobile-menu-style')) {
    const style = document.createElement('style');
    style.id = 'mobile-menu-style';
    style.textContent = `
      .header-nav.mobile-open {
        display: flex !important;
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        flex-direction: column;
        padding: 20px;
        box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        border-top: 1px solid #e0e0e0;
      }
      
      .header-nav.mobile-open a {
        padding: 10px 0;
        border-bottom: 1px solid #f0f0f0;
      }
      
      .header-nav.mobile-open a:last-child {
        border-bottom: none;
      }
      
      .menu-toggle.active span:nth-child(1) {
        transform: rotate(45deg) translate(5px, 5px);
      }
      
      .menu-toggle.active span:nth-child(2) {
        opacity: 0;
      }
      
      .menu-toggle.active span:nth-child(3) {
        transform: rotate(-45deg) translate(7px, -6px);
      }
    `;
    document.head.appendChild(style);
  }
  
  // メニューの開閉
  headerNav.classList.toggle('mobile-open');
  menuToggle.classList.toggle('active');
};